export default __webpack_public_path__ + "static/media/solteiroduplo_11.7c53f09f.jpg";